import { Link } from '@ets/design-system';
import { FormattedMessage } from 'react-intl';

type SpaceCellProps = {
  object: Objekt;
};

const SpaceCell = ({ object }: SpaceCellProps) => {
  return (
    <Link size="s" variant="primary" href={`/storage/space/${object.space.id}`} testId="space">
      {object.space.personal ? <FormattedMessage id="spaces.personalSpace" /> : object.space.name}
    </Link>
  );
};

export default SpaceCell;
